//  对Date的扩展，将 Date 转化为指定格式的String
//  月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
//  年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
//  例子：
//  (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
//  (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
Date.prototype.Format = function (fmt) {
    // author: meizz
    var o = {
        "M+": this.getMonth() + 1, // 月份
        "d+": this.getDate(), // 日
        "h+": this.getHours(), // 小时
        "m+": this.getMinutes(), // 分
        "s+": this.getSeconds(), // 秒
        "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
        S: this.getMilliseconds(), // 毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(
            RegExp.$1,
            (this.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
            );
    return fmt;
};

const windowsBridge = {
    openBrowser: function (url) {
        if (window.external.openBrowser) {
            window.external.openBrowser(url);
        }
    }
}

const macBridge = {
    openBrowser: function (url) {
        if (window.webkit.messageHandlers.openBrowser) {
            window.webkit.messageHandlers.openBrowser.postMessage(
                {
                    url: url
                }
            );
        }
    }
}

const webBridge = {
    openBrowser: function (url) {
        window.open(url);
    }

}

let tunxxInfos = {};
let isStartTunxx = false;

module.exports = {
    changeLastOctetToZero: function (ipAddress) {
        // 将 IP 地址拆分为四个部分
        const octets = ipAddress.split('.');

        // 确保 IP 地址有四个部分
        if (octets.length === 4) {
            // 将最后一部分设置为 0
            octets[3] = '0';

            // 重新组合 IP 地址
            const modifiedIPAddress = octets.join('.');

            return modifiedIPAddress;
        } else {
            // 如果 IP 地址不是有效的 IPv4 地址，返回原始值
            return ipAddress;
        }
    },

    addTunxx: function (pid, ip, ip_count, sendUserlog) {
        console.log("addTunxx", pid, ip);
        if (tunxxInfos[pid]) {
            return;
        }
        if (ip == "0.0.0.0") {
            return;
        }
        if (ip == "253.253.253.253") {
            return;
        }
        let zeroIp = this.changeLastOctetToZero(ip);
        tunxxInfos[pid + "-" + zeroIp] = {
            state: 0,
            pid: pid,
            ip: zeroIp,
            ip_count: ip_count
        }
    },

    startTunxx: function (sendUserlog) {
        if (isStartTunxx) {
            return;
        }
        let pids = Object.keys(tunxxInfos);
        console.log(pids);
        if (pids.length <= 0) {
            return;
        }
        if (window.external.stopTunxx) {
            let ret = window.external.stopTunxx();
            sendUserlog(["stopTunxx", ret])
        } else {
            return;
        }
        for (let index = 0; index < pids.length; index++) {
            const pidIp = pids[index];
            let info = tunxxInfos[pidIp];
            let pid = info.pid;
            console.log(pid, info.ip);
            if (window.external.connectDevice) {
                let ret = window.external.connectDevice(pid);
                sendUserlog(["connectDevice", pid + " " + ret])
            }
            if (window.external.setTunxxInfo) {
                let ret = window.external.setTunxxInfo(pid, info.ip, info.ip_count);
                sendUserlog(["setTunxxInfo", pid + " " + info.ip + " " + info.ip_count + " " + ret])
            }
            if (window.external.getTunxxState) {
                info.state = window.external.getTunxxState(pid);
                sendUserlog(["getTunxxState", pid + " " + info.state])
            }
        }
        if (window.external.startTunxx) {
            let ret = window.external.startTunxx();
            sendUserlog(["startTunxx", ret])
            isStartTunxx = true;
        }
    },
    rebuildServerItems: function (list, nasExPorts) {
        let _that = this;
        for (let i = 0; i < list.length; i++) {
            let item = list[i];
            item.ip_str = _that.ipConvert(item.ip);
            item.ip_num = _that.ipConvertToNum(item.ip);

            switch (item.dtype) {
                case 1:
                    item.type_name = "NAS";
                    break;
                case 2:
                    item.type_name = "路由器";
                    break;
                case 3:
                    item.type_name = "电脑";
                    break;
                case 6:
                    item.type_name = "打印机";
                    break;
                default:
                    item.type_name = "未知";
                    break;
            }

            item.btn = "远程管理";
            item.port = 80;
            if (!item.name) {
                item.name = item.type_name;
            }
            if (item.ports && item.ports.length > 0) {
                item.port = item.ports[0];
            }
            if (
                (item.ip_str.substr(-2) == ".1" || item.dtype == 2) &&
                item.port == 80
            ) {
                item.btn = "路由管理";
                // item.btn = "远程管理";
            } else if (item.port == 80) {
                item.btn = "浏览网页";
            } else if (
                item.port == 5000 ||
                item.port == 5001 ||
                item.port == 8080 ||
                nasExPorts.includes(item.port)
            ) {
                if (item.port == 8800 || item.port == 8801) {
                    item.btn = "Audio";
                } else if (item.port == 7000 || item.port == 7001) {
                    item.btn = "File";
                } else if (item.port == 5080 || item.port == 5443) {
                    item.btn = "Photos";
                } else if (item.port == 9007 || item.port == 9008) {
                    item.btn = "Video";
                } else {
                    if (item.dtype == 1) {
                        item.btn = "NAS管理";
                    } else if (item.dtype == 2) {
                        item.btn = "路由管理";
                    } else {
                        item.btn = "远程管理";
                    }
                }
            } else if (item.port == 3389) {
                item.btn = "远程桌面";
            }

            if (item.button) {
                item.btn = item.button;
            }

            if (item.dtype == 999) {
                item.btn = "端口映射";
            }
        }
    },
    // 根据IP筛选网卡
    getNicByNics: function (nics) {
        let _that = this;
        if (!nics || nics.length < 0) {
            return null;
        }
        let curNics = [];
        for (
            let j = 0; j < nics.length; j++
        ) {
            const nic = nics[j];
            let ip_str = _that.ipConvert(nic.ipv4n);
            if (ip_str.indexOf("169") == 0) {
                continue;
            } else {
                curNics.push(nic);
            }
        }
        if (curNics.length > 0) {
            return curNics[0];
        } else {
            return nics[0];
        }
    },
    isValidIP: function (ip) {
        var reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
        return reg.test(ip);
    },
    bridge: function (client) {
        if (client == "windows") {
            return windowsBridge;
        } else if (client == "mac") {
            return macBridge;
        } else {
            return webBridge;
        }
    },
    ipConvert: function (ip) {
        let part1 = ip & 255;
        let part2 = (ip >> 8) & 255;
        let part3 = (ip >> 16) & 255;
        let part4 = (ip >> 24) & 255;
        return part1 + "." + part2 + "." + part3 + "." + part4;
    },
    ipConvertToNum: function (ip) {
        let part1 = ip & 255;
        let part2 = (ip >> 8) & 255;
        let part3 = (ip >> 16) & 255;
        let part4 = (ip >> 24) & 255;
        return parseInt(part1 + "" + part2 + "" + part3 + "" + part4);
    },
    localStorage: {
        removeItem: function (key) {
            if (typeof localStorage.removeItem === "string") {
                return (localStorage[key] = null);
            } else {
                return localStorage.removeItem(key);
            }
        },
        setItem: function (key, value) {
            if (typeof localStorage.setItem === "string") {
                return (localStorage[key] = value);
            } else {
                return localStorage.setItem(key, value);
            }
        },
        getItem: function (key) {
            return localStorage.getItem(key);
        },
        clear: function () {
            return localStorage.clear();
        },
    },
    getInfoByPid: function (pid) {
        let info = {
            cid: 0,
            did: 0,
            cname: "未知",
            dname: "设备",
        };
        if (pid.length > 6) {
            info.cid = parseInt(pid.substr(-6, 2), 16);
            info.did = parseInt(pid.substr(-4, 2), 16);
        }
        switch (info.cid) {
            case 99:
                info.cname = "电脑";
                info.dname = "pc";
                break;
            case 101:
                {
                    if (info.did == 103) {
                        info.cname = "创米";
                    } else if (info.did == 104) {
                        info.cname = "联想";
                    }
                }
                info.dname = "NAS";
                break;
            case 106:
                info.cname = "极路由";
                info.dname = "路由器";
                break;
            case 108:
                info.cname = "铁威马";
                info.dname = "NAS";
                break;
            case 109:
                info.cname = "爱快";
                info.dname = "路由器";
                break;
            case 110:
                info.cname = "群晖";
                info.dname = "NAS";
                break;
            case 111:
                info.cname = "华为";
                info.dname = "路由器";
                break;
            case 112:
                info.cname = "磊科";
                info.dname = "路由器";
                break;
            case 114:
                info.cname = "海康";
                info.dname = "NAS";
                break;
            case 121:
                info.cname = "360";
                info.dname = "路由器";
                break;
            case 123:
                info.cname = "联想";
                info.dname = "NAS";
                break;
            case 124:
                info.cname = "小米";
                info.dname = "路由器";
                break;
            case 125:
                info.cname = "TOTOLINK";
                info.dname = "路由器";
                break;
            case 126:
                info.cname = "威联通";
                info.dname = "NAS";
                break;
            case 127:
                info.cname = "华硕";
                info.dname = "路由器";
                break;
            case 134:
                info.cname = "测网速";
                info.dname = "路由器";
                break;
            case 137:
                info.cname = "openwrt";
                info.dname = "";
                break;
            default:
                break;
        }
        return info;
    },
    buildSearchServiceList: function (nasWebPort, nasMac, serviceList, data) {
        let _that = this;
        let searchServiceList = [];
        if (data && !data.rtn && data.jd) {
            //当一个服务有多个端口时，需要展示多个端口
            for (let i = 0; i < data.jd.length; i++) {
                let ports = data.jd[i].ports;
                // 过滤离线设备
                // if (data.jd[i].status == 1) {
                // 	continue;
                // }
                if (data.jd[i].dtype) {
                    //不显示没有类型的服务
                    if (ports) {
                        if (ports.length > 1) {
                            //有多个端口需要进行拆分
                            for (let j = 0; j < ports.length; j++) {
                                let item = JSON.parse(JSON.stringify(data.jd[i]));
                                item.ports = [ports[j]];

                                searchServiceList.push(item);
                            }
                        } else {
                            //有一个端口
                            searchServiceList.push(data.jd[i]);
                        }
                    } else {
                        //没有端口
                        if (data.jd[i].status == 1) {
                            //仅添加离线的能够开机的设备
                            searchServiceList.push(data.jd[i]);
                        }
                    }
                }
            }

            _that.rebuildList(
                nasWebPort,
                nasMac,
                searchServiceList,
                serviceList,
                "search"
            );
        }

        return searchServiceList;
    },

    rebuildList: function (nasWebPort, nasMac, list, serviceList, type) {
        let _that = this;

        for (let i = 0; i < list.length; i++) {
            let item = list[i];
            item.ip_str = _that.ipConvert(item.ip);
            item.ip_num = _that.ipConvertToNum(item.ip);

            switch (item.dtype) {
                case 1:
                    item.type_name = "NAS";
                    break;
                case 2:
                    item.type_name = "路由器";
                    break;
                case 3:
                    item.type_name = "电脑";
                    // for test
                    // item.status = 1;
                    break;
                default:
                    item.type_name = "未知";
                    break;
            }

            item.btn = "远程";
            item.port = 80;
            if (!item.name) {
                item.name = item.type_name;
            }
            if (item.ports && item.ports.length > 0) {
                item.port = item.ports[0];
            }
            if (item.ip_str.substr(-2) == ".1" && item.port == 80) {
                item.btn = "路由器管理";
            } else if (item.port == 80) {
                item.btn = "浏览网页";
            } else if (item.port == 5000 || item.port == 8080) {
                item.btn = "NAS管理";
            } else if (item.port == 3389) {
                item.btn = "远程桌面";
            }
        }

        for (let index = list.length - 1; index >= 0; index--) {
            const element = list[index];
            if (element.dtype == 1 && element.port != 5000 && element.port != 8080) {
                // 遍历删除NAS设备非5000或者非8080端口
                if (nasWebPort) {
                    // 考虑有nasWebPort的情况
                    if (element.port != nasWebPort && element.mac != nasMac) {
                        list.splice(index, 1);
                    } else {
                        element.btn = "NAS管理";
                    }
                } else {
                    list.splice(index, 1);
                }
            } else if (
                element.dtype == 3 &&
                element.port != 3389 &&
                !element.status
            ) {
                // 遍历删除在线电脑设备非3389端口
                list.splice(index, 1);
            } else if (element.dtype == 2 && element.port != 80) {
                // 遍历删除路由器设备非80端口
                list.splice(index, 1);
            }
        }

        if (type == "search") {
            // nasWebPort端口
            if (nasWebPort) {
                let isServiceHasNasWebPort = false;
                for (let index = 0; index < serviceList.length; index++) {
                    // 检查nasWebPort是否已经在服务列表
                    const element = serviceList[index];
                    if (element.mac == nasMac && element.port == nasWebPort) {
                        isServiceHasNasWebPort = true;
                        break;
                    }
                }
                if (!isServiceHasNasWebPort) {
                    let isHas = false;
                    for (let index = 0; index < list.length; index++) {
                        const element = list[index];
                        if (element.mac == nasMac && element.port == nasWebPort) {
                            isHas = true;
                            break;
                        }
                    }
                    if (!isHas) {
                        list.push({
                            dtype: 1,
                            ip: _that.curDev.ip,
                            mac: _that.curDev.mac,
                            name: _that.curDev.term.name ? _that.curDev.term.name : nas,
                            port: nasWebPort,
                            ports: [nasWebPort],
                            btn: "NAS管理",
                        });
                    }
                }
            }
        }

        // 按ip排序
        list.sort(function (a, b) {
            return a.ip_num - b.ip_num;
        });
    },
};
